import React, { useEffect, useReducer, createContext } from 'react';
import { AES, enc } from 'crypto-js';
import { DATA_SALT, KEY_ACCESS_TOKEN, KEY_REFRESH_TOKEN, KEY_USER_DETAILS } from '../Utils/Constants/constant';
import KenLoader from '../Components/KenLoader';
import mixpanel from 'mixpanel-browser';

export const initialState = {
  isAuthenticated: false,
  user: null,
  search: null,
  loading: false,
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'LOGIN':
      const existingAccesstoken = localStorage.getItem(KEY_ACCESS_TOKEN);
      const existingRefreshtoken = localStorage.getItem(KEY_REFRESH_TOKEN);

      localStorage.setItem(KEY_ACCESS_TOKEN, action.payload?.accessToken?.token || existingAccesstoken);
      localStorage.setItem(KEY_REFRESH_TOKEN, action.payload?.refreshToken?.token || existingRefreshtoken);

      const userPayload = action.payload || { user: null };
      const data = AES.encrypt(JSON.stringify(userPayload), DATA_SALT).toString();
      localStorage.setItem(KEY_USER_DETAILS, data);
      return {
        ...state,
        loading: action.payload?.loading || state.loading,
        isAuthenticated: userPayload.user && userPayload.user === null ? false : true,
        user: userPayload.user || null,
      };
    case 'LOGOUT':
      localStorage.clear();
      mixpanel.reset();
      return {
        ...state,
        loading: true,
        isAuthenticated: false,
        user: null,
      };
    default:
      return state;
  }
};

export const AuthContext = createContext({ state: initialState, dispatch: () => {} });

export const AuthContextProvider = (props) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const fetchUserData = () => {
    const user = localStorage.getItem(KEY_USER_DETAILS);
    if (user) {
      const parseData = AES.decrypt(user, DATA_SALT).toString(enc.Utf8);
      const parsedUser = JSON.parse(parseData);
      if (!parsedUser?.user) {
        dispatch({
          type: 'LOGOUT',
        });
        return;
      }
      dispatch({
        type: 'LOGIN',
        payload: {
          loading: true,
          user: parsedUser.user,
          accessToken: parsedUser.accessToken,
          refreshToken: parsedUser.refreshToken,
        },
      });
    } else {
      dispatch({
        type: 'LOGOUT',
      });
    }
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  return (
    <AuthContext.Provider
      value={{
        state,
        dispatch,
      }}
    >
      {state.loading ? props.children : <KenLoader />}
    </AuthContext.Provider>
  );
};

export const useAuthContext = () => {
  const context = React.useContext(AuthContext);
  if (!context) {
    throw new Error('useAuthContext must be used within an AuthProvider');
  }
  return context;
};
